import { render, staticRenderFns } from "./donateBlood.vue?vue&type=template&id=c1833fc2&scoped=true"
import script from "./donateBlood.vue?vue&type=script&lang=js"
export * from "./donateBlood.vue?vue&type=script&lang=js"
import style0 from "./donateBlood.vue?vue&type=style&index=0&id=c1833fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1833fc2",
  null
  
)

export default component.exports